
import { useNavigate } from 'react-router-dom';
import { volunteerPositions } from '../../../mocks/volunteerData';

export default function PositionCards() {
  const navigate = useNavigate();

  const handleApply = (positionTitle: string) => {
    navigate(`/volunteer/apply?position=${encodeURIComponent(positionTitle)}`);
  };

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-[#1E1E1E] mb-2 md:mb-4">
            招募岗位
          </h2>
          <p className="text-sm md:text-lg text-[#6C6C6C]">
            选择适合您的岗位，开启志愿服务之旅
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6">
          {volunteerPositions.map((position) => (
            <div
              key={position.id}
              className="bg-white rounded-lg md:rounded-xl border border-[#E0E0E0] p-3 md:p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#2A7A62]/10 rounded-lg flex items-center justify-center mb-2 md:mb-4">
                <i className={`${position.icon} text-xl md:text-3xl text-[#2A7A62]`}></i>
              </div>

              <h3 className="text-sm md:text-xl font-bold text-[#1E1E1E] mb-2 md:mb-3">
                {position.title}
              </h3>

              <div className="mb-2 md:mb-4 flex-grow">
                <div className="text-xs md:text-sm font-semibold text-[#2A7A62] mb-1 md:mb-2">
                  岗位职责：
                </div>
                <ul className="space-y-1 md:space-y-2">
                  {position.responsibilities.map((resp, index) => (
                    <li key={index} className="text-[10px] md:text-sm text-[#6C6C6C] flex items-start">
                      <i className="ri-checkbox-circle-fill text-[#2A7A62] mr-1 md:mr-2 mt-0.5 flex-shrink-0 text-xs md:text-base"></i>
                      <span>{resp}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mb-2 md:mb-4 p-2 md:p-3 bg-[#F9F9F9] rounded-lg">
                <div className="text-[9px] md:text-xs text-[#6C6C6C] mb-1">服务时间</div>
                <div className="text-[10px] md:text-sm text-[#1E1E1E]">{position.timeRequirement}</div>
              </div>

              <div className="mb-2 md:mb-4">
                <span className="inline-block px-2 md:px-3 py-0.5 md:py-1 bg-[#F4B942]/20 text-[#E06B3D] text-[10px] md:text-sm font-semibold rounded-full">
                  {position.quota}
                </span>
              </div>

              <button
                onClick={() => handleApply(position.title)}
                className="w-full bg-[#2A7A62] hover:bg-[#236B54] text-white py-2 md:py-3 rounded-lg text-xs md:text-base font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                立即报名
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
